import { Component, Input } from '@angular/core';
import { Station } from 'src/tmc-yard/client/model/station';
import { StationType } from 'src/tmc-yard/client/model/station-type.enum';

@Component({
    selector: 'app-station-details',
    templateUrl: './station-details.component.html',
    styleUrls: ['./station-details.component.scss']
})
export class StationDetailsComponent {

    @Input() station: Station;

    @Input() selected = false;

    stationType = StationType;

}
